{
  "actions": {
    "new": "New customer",
    "archive": "Archive",
    "restore": "Restore",
    "newInvoice": "New invoice",
    "recordReceipt": "Record receipt",
    "newQuotation": "New quotation",
    "newCreditNote": "New credit note",
    "newDebitNote": "New debit note",
    "statement": "Statement",
    "printStatement": "Print statement",
    "credit": "Unapplied credit and refunds",
    "open": "Open",
    "rowActions": "Actions for {{name}}",
    "export": "Export view",
    "retryFigures": "Load the balance again"
  },
  "fields": {
    "code": "Code",
    "name": "Name",
    "nameAr": "Name in Arabic",
    "company": "Company",
    "mobile": "Mobile",
    "phone": "Phone",
    "email": "Email",
    "address": "Address",
    "city": "City",
    "country": "Country",
    "status": "Status",
    "groups": "Groups",
    "taxNumber": "Tax number",
    "notes": "Notes",
    "createdAt": "Created",
    "updatedAt": "Last changed",
    "contactName": "Name",
    "role": "Role",
    "balance": "Balance",
    "overdue": "Overdue",
    "unallocatedCredit": "Unapplied credit"
  },
  "status": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "ARCHIVED": "Archived",
    "ANONYMISED": "Anonymised"
  },
  "list": {
    "title": "Customers",
    "tableLabel": "Customers",
    "views": "Customer views",
    "view": {
      "current": "All",
      "active": "Active",
      "inactive": "Inactive",
      "archived": "Archived"
    },
    "searchLabel": "Search customers",
    "searchPlaceholder": "Search name, code, mobile…",
    "clearSearch": "Clear search",
    "groupFilter": "Filter by group",
    "allGroups": "All groups",
    "clearFilters": "Clear filters",
    "empty": {
      "title": "No customers yet.",
      "body": "Add your first customer to start selling on account.",
      "filteredTitle": "No customers match.",
      "filteredBody": "Try another name, code or mobile number, or clear the filters.",
      "view": {
        "current": "No customers yet.",
        "active": "No active customers.",
        "inactive": "No inactive customers.",
        "archived": "No archived customers."
      },
      "balance": {
        "owes": "No customer owes you money.",
        "overdue": "Nothing is overdue.",
        "credit": "No customer is in credit."
      }
    },
    "balanceView": {
      "owes": "Owes us",
      "overdue": "Overdue",
      "credit": "In credit"
    },
    "inCredit": "In credit: we owe the customer {{amount}}",
    "overdueMarker": "Part of it is overdue",
    "exportHint_one": "CSV of the {{n}} customer in this view",
    "exportHint_other": "CSV of the {{n}} customers in this view",
    "stats": {
      "label": "Customer figures",
      "active": "Active customers",
      "ofAll": "of {{total}}",
      "activeShare": "{{percent}}% of the customers are active",
      "owed": "Owed to us",
      "owedDetail": "from {{customers}}",
      "overdueShare": "{{percent}}% of what customers owe is overdue",
      "overdue": "Overdue",
      "credit": "In credit",
      "unavailable": "Figures unavailable",
      "customers_one": "{{n}} customer",
      "customers_other": "{{n}} customers"
    }
  },
  "detail": {
    "noContacts": "No contact people yet.",
    "noContactsHint": "Edit the customer to add the people you deal with."
  },
  "new": {
    "title": "New customer",
    "subtitle": "The customer code is assigned when you save."
  },
  "edit": {
    "title": "Edit {{name}}",
    "subtitle": "Edit customer",
    "archivedTitle": "This customer is archived",
    "backToCustomer": "Back to customer"
  },
  "form": {
    "save": "Save customer",
    "saveHint": "Press {{shortcut}} to save",
    "sections": {
      "identity": "Identity",
      "contact": "Contact",
      "address": "Address",
      "classification": "Classification",
      "taxNotes": "Tax and notes",
      "contacts": "Contact people"
    },
    "hints": {
      "company": "The legal or trading name, if different from the customer's name.",
      "groupsUnavailable": "Groups couldn't be loaded. You can add them later.",
      "contacts": "People you deal with at this customer."
    },
    "groupsPlaceholder": "Choose groups",
    "groupsSearch": "Search groups…",
    "groupsEmpty": "No groups found.",
    "groupsClear": "Clear selection",
    "groupsSelected": "{{n}} groups",
    "noContacts": "No contact people yet.",
    "addContact": "Add contact",
    "contactName": "Contact {{n}} name",
    "contactPhone": "Contact {{n}} phone",
    "contactRole": "Contact {{n}} role",
    "removeContact": "Remove contact {{n}}",
    "errors": {
      "title": "The customer wasn't saved",
      "mobileTaken": "This mobile number is already used by another customer.",
      "archived": "Restore this customer before editing it.",
      "pricingForbidden": "Setting a customer's price level, or adding or removing a group that sets prices, needs permission to manage customer groups or prices. Undo that change, or ask someone who has the permission."
    },
    "conflict": {
      "title": "Someone else changed this customer",
      "body": "Your changes weren't saved. Reload to see the latest version, then make your changes again.",
      "reload": "Reload latest"
    },
    "leave": {
      "title": "Discard unsaved changes?",
      "body": "You have changes on this page that haven't been saved.",
      "confirm": "Discard changes",
      "cancel": "Keep editing"
    }
  },
  "archive": {
    "title": "Archive {{name}}?",
    "body": "Archived customers leave the customer list and the pickers, and can't be used on new documents. They stay in the Archived view, and you can restore them at any time.",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "The customer returns to lists and can be used on new documents again."
  },
  "toast": {
    "created": "Customer {{code}} created",
    "updated": "Customer saved",
    "archived": "Customer archived",
    "restored": "Customer restored",
    "exported_one": "Exported {{n}} customer",
    "exported_other": "Exported {{n}} customers",
    "exportedView": "View exported"
  },
  "groups": {
    "title": "Customer groups",
    "subtitle": "Group customers for price lists, reports and filters.",
    "new": "New group",
    "newTitle": "New customer group",
    "newSubtitle": "Name the group in one or both languages.",
    "editTitle": "Edit customer group",
    "save": "Save group",
    "actions": "Actions",
    "editNamed": "Edit {{name}}",
    "deleteNamed": "Delete {{name}}",
    "showMembers": "Show customers in {{name}}",
    "showArchivedMembers": "Show archived customers in {{name}}",
    "archivedMembers_one": "+{{n}} archived",
    "archivedMembers_other": "+{{n}} archived",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "description": "Description",
      "members": "Customers",
      "allowTillCredit": "Allow credit sales at the till",
      "allowTillCreditHint": "Members can buy on account at the till: what they do not pay stays open on the invoice. No credit limit applies.",
      "tillCredit": "Till credit"
    },
    "empty": {
      "title": "No customer groups yet.",
      "body": "Create groups such as Wholesale or Government to filter and report on customers."
    },
    "errors": {
      "nameTaken": "A group with this name already exists.",
      "versionConflict": "Someone else changed this group since you opened it. Close it and open it again to see the change."
    },
    "delete": {
      "title": "Delete {{name}}?",
      "body_one": "The group is removed from its {{n}} customer. The customer itself is kept.",
      "body_other": "The group is removed from its {{n}} customers. The customers themselves are kept.",
      "level": "Its customers lose the {{level}} price level it gives them: they buy at their own level, another group's, or Retail.",
      "confirm": "Delete group"
    },
    "toast": {
      "created": "Group created",
      "updated": "Group saved",
      "deleted": "Group deleted"
    }
  },
  "picker": {
    "placeholder": "Choose a customer",
    "search": "Search name, code or mobile…",
    "empty": "No customer matches.",
    "failed": "Customers couldn't be loaded. Try again."
  },
  "archiveBlocked": {
    "balance": "Settle the balance of {{amount}} first.",
    "credit": "Refund or apply the credit of {{amount}} first.",
    "openCredit": "Apply the credit of {{amount}} to the open invoices first.",
    "checking": "Checking the balance…",
    "unavailable": "The balance couldn't be loaded."
  },
  "errors": {
    "CUSTOMER_HAS_BALANCE": "This customer still owes money or holds credit. Settle the balance and refund or apply the credit, then archive.",
    "CUSTOMER_HAS_BALANCE_SALES_OFF": "This customer still owes money or holds credit, which is settled in Sales. Sales is turned off for your company: once it is turned back on, settle the balance, then archive.",
    "WALK_IN_CUSTOMER": "The walk-in customer can't be archived.",
    "CUSTOMER_HAS_OPEN_CHEQUES": "This customer has received cheques still in hand or deposited and not yet cleared. Archive the customer once they clear, or after recording a bounce or return.",
    "GROUP_IN_USE_one": "This group has a custom price. Delete it on its product page first, then delete the group.",
    "GROUP_IN_USE_other": "This group has {{customPrices}} custom prices. Delete them on the product pages first, then delete the group."
  },
  "profile": {
    "figures": "Account figures",
    "balanceDue": "Balance due",
    "inCredit": "In credit",
    "overdue": "Overdue",
    "oldest": "oldest {{bucket}}",
    "nothingOverdue": "nothing overdue",
    "creditHeld": "Unapplied credit",
    "creditSources_one": "on {{count}} document",
    "creditSources_other": "on {{count}} documents",
    "lastInvoice": "Last invoice",
    "lastReceipt": "Last receipt",
    "netSalesHead": "Net sales",
    "invoiceCount_one": "{{count}} invoice, ex-VAT",
    "invoiceCount_other": "{{count}} invoices, ex-VAT",
    "none": "None yet",
    "aging": "Aging of the balance due",
    "agingCurrency": "OMR",
    "agingFailed": "The aging couldn't be loaded.",
    "agingUnavailable": "Aging unavailable.",
    "nothingOwed": "Nothing owed",
    "figuresFailed": "The account figures couldn't be loaded.",
    "bucket": {
      "current": "Not yet due",
      "days1to30": "1–30",
      "days31to60": "31–60",
      "days61to90": "61–90",
      "over90": "90+"
    },
    "bucketLong": {
      "days1to30": "1–30 days",
      "days31to60": "31–60 days",
      "days61to90": "61–90 days",
      "over90": "over 90 days"
    },
    "tabs": {
      "label": "Customer sections",
      "overview": "Overview",
      "invoices": "Invoices",
      "receipts": "Receipts",
      "creditNotes": "Credit notes",
      "quotations": "Quotations",
      "statement": "Statement",
      "tasks": "Tasks",
      "attachments": "Attachments"
    },
    "walkIn": "Walk-in",
    "archivedBanner": "Archived on {{date}}. It can't be used on new documents; its records stay readable.",
    "inactiveBanner": "Inactive: no new invoices, debit notes or quotations. Receipts, credit notes and refunds still work, so old balances can be settled.",
    "attention": {
      "title": "Needs attention",
      "none": "Nothing needs attention.",
      "unavailable": "Unavailable.",
      "overdue_one": "overdue invoice",
      "overdue_other": "overdue invoices",
      "drafts_one": "draft invoice to post",
      "drafts_other": "draft invoices to post",
      "draftNotes_one": "draft credit note to post",
      "draftNotes_other": "draft credit notes to post",
      "pending_one": "quotation awaiting approval",
      "pending_other": "quotations awaiting approval",
      "credit": "Unapplied credit — apply or refund"
    },
    "recent": {
      "title": "Recent documents",
      "none": "No documents yet."
    },
    "kind": {
      "invoice": "Invoice",
      "receipt": "Receipt",
      "creditNote": "Credit note",
      "debitNote": "Debit note"
    },
    "sections": {
      "contact": "Contact",
      "address": "Address",
      "classification": "Classification",
      "notes": "Notes",
      "contacts": "Contact people",
      "record": "Record"
    },
    "noContact": "No mobile, phone, email or company recorded.",
    "showAllNotes": "Show all"
  },
  "docs": {
    "views": {
      "invoices": {
        "label": "Invoice views",
        "all": "All",
        "open": "Open",
        "overdue": "Overdue",
        "draft": "Drafts",
        "void": "Void"
      },
      "receipts": {
        "label": "Receipt views",
        "all": "All",
        "credit": "Unapplied credit",
        "void": "Void"
      },
      "creditNotes": {
        "label": "Credit note views",
        "all": "All",
        "credit": "Unapplied credit",
        "draft": "Drafts",
        "void": "Void"
      },
      "quotations": {
        "label": "Quotation views",
        "all": "All",
        "pending": "Pending",
        "approved": "Approved",
        "converted": "Converted",
        "rejected": "Rejected"
      }
    },
    "kindFilter": "Filter by type",
    "allKinds": "Invoices and debit notes",
    "empty": {
      "invoices": "No invoices for this customer yet.",
      "receipts": "No receipts from this customer yet.",
      "creditNotes": "No credit notes for this customer yet.",
      "quotations": "No quotations for this customer yet.",
      "view": "Nothing in this view.",
      "next": {
        "invoices": "Create the first invoice, or convert an approved quotation.",
        "receipts": "Record a receipt when the customer pays.",
        "creditNotes": "Credit a return or a price reduction from an invoice.",
        "quotations": "Send the customer a price offer."
      }
    },
    "rowActions": "Actions for {{number}}",
    "draft": "draft",
    "open": "Open",
    "edit": "Edit",
    "post": "Post…",
    "delete": "Delete draft…",
    "void": "Void…",
    "print": "Print preview",
    "recordReceipt": "Record receipt",
    "creditNote": "Credit note",
    "allocate": "Apply to invoices…",
    "refund": "Refund credit",
    "convert": "Convert to invoice…"
  },
  "credit": {
    "title": "Unapplied credit",
    "held": "{{amount}} in total",
    "sources": "Documents with unapplied credit",
    "sourcesHint": "Receipts and credit notes with money not yet applied to invoices or refunded.",
    "none": "No unapplied credit.",
    "truncated": "Only the newest are listed.",
    "available": "Unapplied",
    "allocate": "Apply",
    "refund": "Refund",
    "refunds": "Refunds paid",
    "noRefunds": "No refunds yet.",
    "allRefunds": "All refunds of this customer",
    "source": {
      "RECEIPT": "Receipt",
      "CREDIT_NOTE": "Credit note"
    },
    "applyTo": "Apply {{number}} to invoices",
    "refundFrom": "Refund from {{number}}"
  },
  "quickCreate": {
    "action": "New customer",
    "title": "New customer",
    "body": "The essentials now; the rest on the customer’s page.",
    "save": "Add customer",
    "created": "Customer {{name}} added",
    "later": "Address, groups, tax number and contact people can be added on the customer’s page.",
    "actionTyped": "New customer “{{typed}}”"
  },
  "anonymised": {
    "label": "Anonymised customer {{code}}",
    "bannerTitle": "Anonymised on {{date}}",
    "bannerBody": "This customer's personal data was removed under the data retention policy. Only the code is kept on its history, and it cannot be edited or restored.",
    "editNotice": "Customer {{code}} was anonymised and cannot be edited."
  },
  "priceLevel": {
    "label": "Price level",
    "inherit": "From group (or Retail)",
    "inheritFrom": "From group: {{level}} ({{group}})",
    "inheritNone": "From group: none, so Retail",
    "inheritHint": "The level of their groups; Retail when no group sets one",
    "none": "None",
    "noneHint": "Members buy at their own level, else Retail",
    "customerHint": "The prices invoices, quotations and the till use for this customer.",
    "readOnlyHint": "Changing it needs permission to manage customer groups or prices.",
    "groupHint": "Customers in this group buy at this level, unless they have a level of their own.",
    "fromGroup": "{{level}} · from their group",
    "fromGroupNamed": "{{level}} · from the {{group}} group",
    "fact": "{{level}} prices",
    "factFromGroup": "{{level}} prices · from group"
  },
  "customPrices": {
    "title": "Custom prices",
    "empty": "None yet. Custom prices are set on a product's page.",
    "exVat": "Prices before VAT.",
    "perUnit": "per {{unit}}",
    "from": "from {{date}}",
    "until": "until {{date}}",
    "between": "{{from}} – {{to}}",
    "shown": "Showing {{shown}} of {{total}}."
  },
  "salesperson": {
    "label": "Account manager",
    "hint": "The salesperson credited with the customer’s new sales unless a document names another.",
    "none": "No account manager"
  }
}
